var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":"","color":"#e9c46a","open-on-hover":"","open-delay":"250","disabled":_vm.disabled},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_vm._t("default",null,{"on":on,"attrs":attrs})]}}],null,true)},[_c('span',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }